import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../screens/User/Home/Home.css";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <section class="py-5">
          <div class="container-fluid" ref={this.myRefContact}>
            <h2 class="text-center mt-5" style={{ marginBottom: "4rem" }}>
              Want to work together? Great, I'm available
            </h2>
            <div class="row ">
              <div class="col-md-4 mb-3 mb-md-0 ">
                <h5>About</h5>
                <p class="mb-5 text-muted">
                  I am a professional Web & Mobile App Developer for 2 years. I
                  have extensive knowledge of front-end JavaScript and browser
                  APIs I create successful Reponsive Websites and Mobile
                  Applications that are fast, easy to use, and built with best
                  practices.
                </p>
              </div>
              <div class="col-md-4">
                <div class="d-flex">
                  <img
                    class="mb-3 mr-3"
                    src={require("../images/map-marker.svg")}
                    alt=""
                  />
                  <h5 style={{ display: "block" }}>Address</h5>
                </div>
                <p style={{ marginLeft: "1.8rem" }} class="text-muted">
                  Karachi, Pakistan, 75900
                </p>
                <div class="d-flex">
                  <img
                    class="mb-3 mr-3"
                    src={require("../images/envelope.svg")}
                    alt=""
                  />
                  <h5 style={{ display: "block" }}>Email</h5>
                </div>
                <p style={{ marginLeft: "1.8rem" }} class="text-muted">
                  adnanahmed818@gmail.com
                </p>
              </div>
              <div class="col-md-4">
                <div class="d-flex">
                  <img
                    class="mb-3 mr-3"
                    src={require("../images/phone.svg")}
                    alt=""
                  />
                  <h5 style={{ display: "block" }}>Phone</h5>
                </div>
                <p style={{ marginLeft: "1.8rem" }} class="text-muted">
                  +92 345 304 8496
                </p>
                <div class="d-flex">
                  <img
                    class="mb-3 mr-3"
                    src={require("../images/calendar-o.svg")}
                    alt=""
                  />
                  <h5 style={{ display: "block" }}>Social Media</h5>
                </div>
                <p style={{ marginLeft: "1.8rem" }} class="text-muted">
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://api.whatsapp.com/send?phone=923453048496&text=&source=&data="
                    target="blank"
                    data-tip="Whatsapp"
                    data-place="left"
                  >
                    {/* <Icon size={32} icon={whatsapp} /> */}
                    <i class="fab fa-whatsapp-square fa-2x"></i>
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://github.com/fidato818"
                    target="blank"
                    data-tip="Github"
                  >
                    {/* <Icon size={32} icon={github} /> */}
                    <i class="fab fa-github-square fa-2x"></i>
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://www.facebook.com/millions818"
                    target="blank"
                    data-tip="Facebook"
                  >
                    {/* <Icon size={32} icon={facebookOfficial} /> */}
                    <i class="fab fa-facebook-square fa-2x"></i>
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://www.linkedin.com/in/adnan-ahmed-28160298/"
                    target="blank"
                    data-tip="linkedn"
                  >
                    <i class="fab fa-linkedin fa-2x"></i>
                    {/* <Icon size={32} icon={linkedinSquare} /> */}
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://twitter.com/AdnanAhmed_818"
                    target="blank"
                    data-tip="twitter"
                  >
                    {/* <Icon size={32} icon={twitter} /> */}
                    <i class="fab fa-twitter-square fa-2x"></i>
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="https://www.instagram.com/adnan_ahmed818/"
                    target="blank"
                    data-tip="Instagram"
                  >
                    <i class="fab fa-instagram fa-2x"></i>
                  </a>
                  <a
                    className="asd"
                    style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                    href="/project-video"
                    // target="blank"
                    data-tip="Youtube"
                  >
                    <i class="fab fa-youtube-square fa-2x"></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>

        <footer
          data-section-id="1"
          data-category="footers"
          data-component-id="2c0d_11_02_awz"
          class="py-3"
        >
          <div class="container-fluid">
            <div class="d-flex justify-content-center mt-2 border-bottom pb-2">
              {/* <h5 class="mr-0  mb-0 order-1 order-md-2">
                <a href="#" data-config-id="brand">
                  Adnan Ahmed
                </a>
              </h5> */}
            </div>
            <div class="d-flex justify-content-center mt-2">
              <h5 class="mb-0 mt-2  text-muted" data-config-id="copyright">
                Handcrafted by Me
                <a data-tip="Adnan Ahmed" data-place="top">
                  <i
                    style={{
                      color: "red",
                      // color: "rgb(118, 102, 223)",
                      marginLeft: 5,
                      marginRight: 5,
                    }}
                    class="fas fa-heart fa-1x"
                    //   data-tip="Adnan Ahmed"
                  ></i>
                  {/* <i class="fas fa-heart"></i> */}
                </a>
                <b
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Adnan Ahmed"
                >
                  {new Date().getFullYear()}
                </b>
              </h5>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(Footer);
